export const DEFAULT = '/';
export const MEETING = '/meeting/:meetingId';
export const PUBLIC_MEETING = '/m/:sharecode/:medium?';
export const DASHBOARD = '/dashboard';
export const CUSTOMER = '/customer';
export const CUSTOMER_CREATE = '/customer/create';
export const CUSTOMER_EDIT = '/customer/edit/:id';
export const CUSTOMER_VIEW = '/customer/view/:id';
export const CALENDAR = '/calendar';
export const LIBRARY = '/library';
export const TODO = '/todo';
export const REPORT = '/report';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const ADMIN = '/admin';
export const ADMIN_DETAILS = '/admin/:id';
export const ACTIVITY = '/activity';
export const SETTINGS = '/settings';
export const PROFILE = '/profile';
export const PUBLIC_CONTENT_VIEWER = '/content/:sharecode';
export const TEMPLATE_BUILDER = '/template/:mode/:templateId';